import { Link } from "react-router-dom";
import { colors } from "@/theme";

export function Logo({ size = 22, tagline = true, color = colors.onSurface }) {
  return (
    <Link to="/" data-testid="brand-logo" style={{ textDecoration: "none", display: "inline-flex", flexDirection: "column", lineHeight: 1 }}>
      <span className="font-display" style={{ fontSize: size, fontWeight: 700, color, letterSpacing: 0.5 }}>
        Garlic
      </span>
      {tagline && (
        <span className="eyebrow" style={{ fontSize: 8.5, letterSpacing: 3, marginTop: 2, color: colors.mutedText }}>
          BY URBAN NEST
        </span>
      )}
    </Link>
  );
}
